/**
 * Employee Web — `/no-access` (ungated).
 *
 * Landing screen for an authenticated user whose effective permissions
 * hydrated EMPTY (`200 []` — a newly-provisioned account with zero grants, or a
 * fail-closed `/effective-permissions` fetch). `requirePermission` redirects
 * such a user here instead of a permission-gated fallback.
 *
 * This route carries NO `requirePermission` gate — only the parent `_auth`
 * auth check. That is intentional and load-bearing: routing a zero-permission
 * user to any gated route would loop. An ungated screen can never re-trigger a
 * gate, so the loop is impossible.
 */
import { createFileRoute } from "@tanstack/react-router";
import { NoAccessScreen } from "@linkhr/design-system";

export const Route = createFileRoute("/_auth/no-access")({
  staticData: { breadcrumb: { labelKey: "no_access.title" } },
  component: NoAccessScreen,
});
